<div class="life-at-xyz-content">
    <div class="align-h">
        <h2 class="width-250 font-40 margin-right-50">Life at ITI Mutual Fund</h2>
        <p class="life-at-xyz-content-p stretch font-20 margin-left-80">
            In a dynamic and fast-growing economy, mutual funds have opened the door to new, modern and attractive investing opportunities. Now more than ever, we have the freedom to dream the impossible and the resources to achieve it.
            <br>
            The chance to make a difference is here. Let your best self shine.
        </p>
    </div>
    <div class="life-at-xyz-tabs">
        <div
            id="carouselExample"
            class="carousel slide"
            data-ride="carousel"
        >
            <ol class="carousel-indicators">
                <li
                    *ngFor="let item of banners; let i = index"
                    data-target="#carouselExample"
                    class="{{ i === 0 ? 'active' : '' }}"
                    attr.data-slide-to="{{ i }}"
                ></li>
            </ol>
            <div class="carousel-inner">
                <div
                    class="carousel-item"
                    *ngFor="let item of banners; let i = index"
                    [ngClass]="{ active: i === 0 }"
                >
                    <div class="ceo-page-carosel-img career-banner-mobile">
                        <img
                            *ngIf="item?.filePath"
                            [src]="item?.filePath"
                            [alt]="item?.name"
                        >
                        <!-- NO DATA -->
                        <img
                            *ngIf="!item?.filePath"
                            src="assets/dummy/dummy.png"
                            alt="{{ item?.name }}"
                        >

                    </div>
                </div>
            </div>
            <a
                class="carousel-control-prev"
                href="#carouselExample"
                role="button"
                data-slide="prev"
            >
                <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
            </a>
            <a
                class="carousel-control-next"
                href="#carouselExample"
                role="button"
                data-slide="next"
            >
                <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</div>
